import { LssProp } from '@lucidhq/lucidium';

import { Status } from '@/components';

export enum PanelPaymentMethodEnumV2 {
  active = 'active',
  deactivated = 'deactivated',
}

export const PanelPaymentMethodMapV2 = {
  [PanelPaymentMethodEnumV2.active]: 'Enabled',
  [PanelPaymentMethodEnumV2.deactivated]: 'Disabled',
} as const;

const PanelStatusColorMap: Record<PanelPaymentMethodEnumV2, LssProp> = {
  [PanelPaymentMethodEnumV2.active]: {
    borderColor: 'success400',
    bg: 'success100',
  },
  [PanelPaymentMethodEnumV2.deactivated]: {
    borderColor: 'danger400',
    bg: 'danger100',
  },
};

export type PanelPaymentMethodTypeV2 = keyof typeof PanelPaymentMethodMapV2;

export interface PanelPaymentMethodPropsV2 {
  status: PanelPaymentMethodTypeV2;
}

export const PanelPaymentMethodStatusV2 = ({
  status,
}: PanelPaymentMethodPropsV2) => (
  <Status
    status={status}
    colorMap={PanelStatusColorMap}
    statusMap={PanelPaymentMethodMapV2}
    width="90px"
  />
);
